<template>
  <div class="main" @mousedown="canvasOut" v-show="!hideEditStory">
    <app-header v-bind="headerConfig" @cut="cutStoryMenu" ref="header"></app-header>
    <mt-popup class="auto-save-popup" :modal=false v-model="moduleState.autoSave" position="top">
      自动保存成功
    </mt-popup>
    <div class="game-preview">
      <div class="guide" v-if="guide">
        <p class="note">点击下方文本框<br/>开始新对白</p>
      </div>
      <div class="story-loading-popup" v-show="moduleState.isStoryLoading">
        <mt-spinner type="double-bounce" color="#ff6600" class="story-loading"></mt-spinner>
      </div>
      <game-preview-box></game-preview-box>
    </div>
    <edit-story-base></edit-story-base>
    <!-- 章节列表 -->
    <chapter-list v-if="moduleState.chapterList"></chapter-list>
    <adjustment-popup v-if="moduleState.adjustmentPopup"></adjustment-popup>

    <story-menu v-if="moduleState.storyMenu"></story-menu>
    <edit-story-text v-if="moduleState.editStoryText && !guideConf.isShow"></edit-story-text>

    <div v-if="guideConf.isShow" class="primary-guide" @click="primaryGuideGlobal">
      <div class="count" v-text="guideConf.nowProgress + '/' + guideConf.length">
        1/6
      </div>
      <div :class="'step-'+ guideConf.nowProgress" class="step">
        <template v-if="guideConf.nowProgress === 3">
          <img :src="'../../static/image/step_' + guideConf.nowProgress + '.png?v=1'" class="slogan"
               :style="{'bottom': setStepLocation(3, 'slogan')}">
          <i class="hollow" @click.stop="guideAction" :style="{'bottom': setStepLocation(3, 'btn')}"></i>
        </template>
        <template v-else-if="guideConf.nowProgress === 2">
          <img :src="'../../static/image/step_' + guideConf.nowProgress + '.png?v=1'" class="slogan"
               :style="{'bottom': setStepLocation(2, 'slogan')}">
          <i class="hollow" @click.stop="guideAction" :style="{'bottom': setStepLocation(2, 'btn')}"></i>
        </template>
        <template v-else>
          <img :src="'../../static/image/step_' + guideConf.nowProgress + '.png?v=1'" class="slogan">
          <i class="hollow" @click.stop="primaryGuideGlobal" v-if="guideConf.nowProgress === 5"></i>
          <i class="hollow" @click.stop="guideAction" v-else></i>
        </template>
        <edit-story-text v-if="moduleState.editStoryText && guideConf.isShow"></edit-story-text>
      </div>
    </div>
    <malib-music v-if="moduleState.musicLibrary"></malib-music>
    <malib-bg v-if="moduleState.imageLibrary"></malib-bg>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import store from '../store/store';
  import AppHeader from '../components/header';
  import ChapterList from '../components/chapter_list';
  import EditStoryBase from '../components/edit_story_base';
  import StoryMenu from '../components/story_menu';
  import ChaptersSet from '../components/chapters_set';
  import {ComponentName, Methods} from '../const/common';
  import EditStoryText from '../components/edit_story_text';
	import MalibBG from '../components/malib_bg';
  import MalibMusic from '../components/malib_music';
  import AdjustmentPopup from '../components/adjustment_popup';

  export default {
    name: 'edit_story',
    components: {
      'app-header': AppHeader,
      'chapter-set': ChaptersSet,
      'chapter-list': ChapterList,
      'story-menu': StoryMenu,
      'edit-story-base': EditStoryBase,
      'malib-bg': MalibBG,
      'malib-music': MalibMusic,
      'edit-story-text': EditStoryText,
      'adjustment-popup': AdjustmentPopup
    },
    computed: {
      isVisualEdit() {
        return store.state.visualEdit;
      },
      ...mapState(['moduleState', 'hideEditStory', 'guide', 'isStoryLoading', 'guideConf', 'viewHeight', 'visualEdit'])
    },
    store,
    data() {
      return {
        headerConfig: {
          title: 'editStory',
          isStoryMenu: true,
          backNote: store.state.nextPageHeaderConf.editStory.backNote,
          backPage: store.state.nextPageHeaderConf.editStory.backPage,
          closeModule: ComponentName.EDIT_STORY
        },
        storyMenu: false
      }
    },
    methods: {
      setStepLocation(step, type) {
        var size = (document.documentElement.clientWidth / 3.6), _res = 0;

        if (step === 3) {
          _res = (this.guideConf.toolY + .03 * size);

          if (type === 'slogan') {
            _res = _res + .69 * size;
          }
        } else if (step === 2) {
          _res = (this.guideConf.toolY - size) - .12 * size;

          if (type === 'slogan') {
            _res = _res + 1.23 * size;
          }
        }

        if (type !== 'slogan') {
          return -((100 * size) - _res) + 'px';
        } else {
          return _res + 'px';
        }
      },
      primaryGuideGlobal() {
        if (this.guideConf.nowProgress === 5) {
          store.state.guideConf.isShow = false;
          localStorage.setItem('primaryGuide', '1');
        }
        Methods.checkChapterHash(109);
      },
      guideAction() {
        var _key = 'step' + this.guideConf.nowProgress, _res = true,
          _store = store.state.guideConf;

        if (_store.nowProgress === 3) {
          _res = !_store.dispose[_key];
        }
        _store.dispose[_key] = _res;
        Methods.checkChapterHash(110);
      },
      canvasOut() {
        Methods.canvasOut();
      },
      cutStoryMenu(b) {
        this.storyMenu = b;
      },
      changeUIShow(bool) {
        Middle.MiddleCommand.changeUIShow(bool);
      }
    },
    created() {
      let guideKey = localStorage.getItem('primaryGuide');
      let isNewCreate = store.state.myStorysLength <= 0;
      if ((!guideKey || !guideKey === '1') && location.href.indexOf('mark=wx') <= -1) {
        let _store = store.state.guideConf;

        if(isNewCreate){
          _store.isShow = true;
        }
      }
    },
    mounted() {
      var _this = this, editTypeHeight = null, storyWinHeight = null, resizeTimer = null;

      this.$nextTick(function () {
        editTypeHeight = document.getElementById('editType').clientHeight;
        storyWinHeight = this.viewHeight - this.$refs.header.$el.clientHeight - editTypeHeight;
        egret.setRunning(false);
        try {
          egret.runEgret({renderMode: "canvas", audioType: 0});
        } catch (e) {
          console.log("出错了:" + e.stack);
          ErrorUpdate.getUserInfoUpErro(appVersion, "程序错误:" + e.stack,"release")
        }
        Methods.initialChapterJump(Middle.EditData.chapter);
        Middle.MiddleCommand.Resize(document.documentElement.clientWidth, storyWinHeight, editTypeHeight);
        this.changeUIShow(!this.visualEdit);
      });

      window.onresize = function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          Middle.MiddleCommand.Resize(document.documentElement.clientWidth, storyWinHeight, editTypeHeight);
        }, 600)
      }
    },
    watch: {
      isVisualEdit() {
        this.$nextTick(function () {
          this.changeUIShow(!this.visualEdit);
        })
      }
    }
  }
</script>

<style scoped>
  @import "../style/css/edit_story.css";
</style>



// WEBPACK FOOTER //
// src/components/edit_story.vue